import React, { Component } from 'react'
import { Dispatch } from 'react-redux'

type Props = {
    school: Object,
    schoolPackage: String,
    dispatch: Dispatch<any>,
}

type State = {
    access: Array,
}

export class AbstractAttendanceComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            access: this.props.schoolPackage != null ? JSON.parse(this.props.schoolPackage) : [],
        }
    }
}

export function mapStateToProps(state: Object) {
    return {
        school: state.school,
        schoolPackage: state.schoolPackage,
    }
}
